<ng-template #loadingOrError>
	<copo-loading-spinner *ngIf="isLoading"></copo-loading-spinner>
</ng-template>

<div class="copo-section copo-error-label" *ngIf="!isSoldToAvailable">
	<span translate>fastlane.soldto.shipto.error</span>
</div>

<ng-container *ngIf="!isLoading && !isError && isSoldToAvailable else loadingOrError">

	<div class="copo-container">
		<div class="copo-section">
			<div class="copo-section-header">
				<span translate>offers.request.info</span>
			</div>

			<div class="copo-section-body">
				<div class="copo-grid">

					<div class="copo-grid-row">
						<div class="copo-grid-row-column">
							<mat-form-field class="copo-form-field" [hideRequiredMarker]="true">
								<mat-label translate>offers.create.details.customer.offer-name</mat-label>
								<input
									#rfqRefField
									type="text"
									matInput
									spellcheck="false"
									autocomplete="off"
									maxlength="120"
									[formControl]="form.getFormRfqRef()"
								>
								<mat-icon *ngIf="!form.getFormRfqRef().value" color="accent" class="pencil-icon-size" svgIcon="copo_pencil" matSuffix>
								</mat-icon>
								<button type="button" *ngIf="form.getFormRfqRef().value" matSuffix mat-icon-button (click)="form.getFormRfqRef().reset('')" tabindex="-1">
									<mat-icon svgIcon="md:close" class="copo-small-close"></mat-icon>
								</button>
								<mat-hint align="end">{{rfqRefField.value.length || 0}}/120</mat-hint>
								<mat-error *ngIf="form.getFormRfqRef().hasError('required')">
									<span translate>offers.create.details.customer.offer-name.error.mandatory</span>
								</mat-error>
							</mat-form-field>
						</div>
						<div class="copo-grid-row-column">
							<!-- SoldTo -->
							<mat-form-field class="copo-form-field" [hideRequiredMarker]="true">
								<mat-label translate>eoffer.customer</mat-label>
								<mat-select [formControl]="form.getFormSoldTo()" (selectionChange)="changeSoldToValues()" #soldToField>
									<mat-option
										*ngFor="let soldTo of soldToBocList|copoSortOptions:false:configForBoc"
										[value]="soldTo.businessId"
										[matTooltip]="soldTo.name +' / '+ soldTo.city"
									>
										{{soldTo.name}}&nbsp;/&nbsp;{{soldTo.city}}
									</mat-option>
								</mat-select>
								<mat-error *ngIf="form.getFormSoldTo().hasError('required')">
									<span translate>eoffer.mandatory.soldTo.reference</span>
								</mat-error>
							</mat-form-field>
						</div>
						<div class="copo-grid-row-column-2"></div>
					</div>
					<div class="copo-grid-row">
						<div class="copo-grid-row-column" *ngIf="getCustomerInfo()">
							<!-- ShipTo -->
							<mat-form-field class="copo-form-field" [hideRequiredMarker]="true">
								<mat-label translate>eoffer.wizard.delivery.address</mat-label>
								<mat-select [formControl]="form.getFormShipTo()" (selectionChange)="changeBocValues()" #shipToField>
									<mat-option *ngFor="let shipTo of getShipToList()|copoSortOptions:false:configForBoc" [value]="shipTo.businessId">
										<div class="copo-offer-ship-to-name" [matTooltip]="shipTo.name +' / '+ shipTo.city">{{shipTo.name}}&nbsp;/&nbsp;{{shipTo.city}}</div>
										<div class="copo-offer-ship-to-address" *ngIf="shipToField.panelOpen" [matTooltip]="shipTo.address +' '+ (shipTo.postalCode ? shipTo.postalCode : '') + ' ' + shipTo.city + ' (' + shipTo.country + ')'">
											{{shipTo.address}} {{shipTo.postalCode}} {{shipTo.city}} ({{shipTo.country}})
										</div>
									</mat-option>
								</mat-select>
								<mat-error *ngIf="form.getFormShipTo().hasError('required')">
									<span translate>eoffer.mandatory.delivery.address</span>
								</mat-error>
							</mat-form-field>
						</div>
						<div class="copo-grid-row-column" *ngIf="getCustomerInfo()">
							<!-- EndUser -->
							<mat-form-field class="copo-form-field" [hideRequiredMarker]="true">
								<mat-label translate>eoffer.create.enduser</mat-label>
								<mat-select [formControl]="form.getFormEndUser()" (selectionChange)="changeBocValues()" #endUserField>
									<mat-option *ngFor="let endUser of getEndUserList()|copoSortOptions:false:configForBoc" [value]="endUser.businessId"
										[matTooltip]="endUser.name +' / '+ endUser.city">
										{{endUser.name}}&nbsp;/&nbsp;{{endUser.city}}
									</mat-option>
								</mat-select>
								<mat-error *ngIf="form.getFormEndUser().hasError('required')">
									<span translate>eoffer.mandatory.enduser.reference</span>
								</mat-error>
							</mat-form-field>
						</div>
						<div class="copo-grid-row-column-2"></div>
					</div>
					<div class="copo-header-product-infos-label" *ngIf="!getCustomerInfo()" translate>offers.soldTo.selection.text</div>
				</div>
			</div>
		</div>
		<div class="copo-section" *ngIf="getCustomerInfo()">
			<div class="copo-section-header">
				<span translate>offers.commitment.period</span>
			</div>
			<div class="copo-section-body">
				<div class="copo-grid">
					<span *ngIf="wasChecked && (form.getFormPeriod().getFormPeriodStartMonth().hasError('required') 
						|| form.getFormPeriod().getFormPeriodEndMonth().hasError('required'))"
						#periodComponent
						[ngClass]="{'period-info copo-offer-alert': wasChecked 
							&& (form.getFormPeriod().getFormPeriodStartMonth().hasError('required') 
							|| form.getFormPeriod().getFormPeriodEndMonth().hasError('required'))}"
						translate
					>eoffer.select.period.info</span>
					<copo-offer-utils-period #periodComponent
					[ngClass]="{'copo-offer-alert-period': wasChecked && form.getFormPeriod().getFormPeriodStartMonth().hasError('required')}"
					[form]="form.getFormPeriod()">
					</copo-offer-utils-period>
				</div>
			</div>
		</div>
		<div class="copo-section" *ngIf="getCustomerInfo()">
			<div class="copo-section-header">
				<span translate>offers.commercial.terms</span>
			</div>
			<div class="copo-section-body">
				<div class="copo-grid">
					<div class="copo-grid-row">
						<div class="copo-grid-row-column">
							<!-- Idd -->
							<mat-form-field class="copo-form-field" [hideRequiredMarker]="true">
								<mat-label translate>eoffer.delivery.date</mat-label>
								<mat-select [formControl]="form.getFormIdd()" #iddField>
									<mat-option *ngFor="let idd of iddList|copoSortOptions:false:config" [value]="idd.code">
										{{idd.description}}
									</mat-option>
								</mat-select>
								<mat-error *ngIf="form.getFormIdd().hasError('required')">
									<span translate>eoffer.mandatory.idd.reference</span>
								</mat-error>
							</mat-form-field>
						</div>
						<div class="copo-grid-row-column">
							<!-- Currency -->
							<mat-form-field class="copo-form-field" [hideRequiredMarker]="true">
								<mat-label translate>offers.create.details.field.currency</mat-label>
								<mat-select [formControl]="form.getFormCurrency()">
									<mat-option *ngFor="let currency of currencyList|copoSortOptions:false:config" [value]="currency.code">
										{{currency.code}} - {{currency.description}}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div class="copo-grid-row-column">
							<!-- Pricing Unit -->
							<mat-form-field class="copo-form-field" [hideRequiredMarker]="true">
								<mat-label translate>eoffer.pricing.unit</mat-label>
								<mat-select [formControl]="form.getFormPricingUnit()">
									<mat-option *ngFor="let unit of unitList|copoSortOptions:false:configForIncotList" [value]="unit.code">
										<span>{{unit.code}} - {{unit.description}}</span>
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</div>
					<div class="copo-grid-row">
						<div class="copo-grid-row-column">
							<!-- Tmode -->
							<mat-form-field class="copo-form-field" [hideRequiredMarker]="true">
								<mat-label translate>eoffer.transport.mode</mat-label>
								<mat-select [formControl]="form.getFormTmode()" #tmodeField>
									<mat-option *ngFor="let tmod of tmodList|copoSortOptions:false:config" [value]="tmod.code">
										{{tmod.description}}
									</mat-option>
								</mat-select>
								<mat-error *ngIf="form.getFormTmode().hasError('required')">
									<span translate>eoffer.mandatory.tmode.reference</span>
								</mat-error>
							</mat-form-field>
						</div>
						<div class="copo-grid-row-column">
							<!-- Incot -->
							<mat-form-field class="copo-form-field" [hideRequiredMarker]="true">
								<mat-label translate>eoffer.incoterms</mat-label>
								<mat-select [disabled]="!isTmode" [formControl]="form.getFormIncoterm()" #incotField>
									<mat-option *ngFor="let incot of incoTerms|copoSortOptions:false:config" [value]="incot.code">
										{{incot.code}} - {{incot.description}}
									</mat-option>
								</mat-select>
								<mat-error *ngIf="form.getFormIncoterm().hasError('required')">
									<span translate>eoffer.mandatory.incot.reference</span>
								</mat-error>
							</mat-form-field>
						</div>
						<div class="copo-grid-row-column"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<copo-offer-wizard-stepprodspec *ngIf="getCustomerInfo()" [wasChecked]="wasChecked"></copo-offer-wizard-stepprodspec>
</ng-container>